module.exports = __webpack_public_path__ + "img/active-News.32dfc78d.jpg";